import { render } from "./AnimeActorCard.vue?vue&type=template&id=a3d3c798&scoped=true"
import script from "./AnimeActorCard.vue?vue&type=script&lang=js"
export * from "./AnimeActorCard.vue?vue&type=script&lang=js"

import "./AnimeActorCard.vue?vue&type=style&index=0&id=a3d3c798&scoped=true&lang=css"

import exportComponent from "/Users/bits008/Project/web/btv-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3d3c798"]])

export default __exports__